import { useSelector } from 'react-redux';
import { getSearcherResults } from '.';
import { TRootState } from '../../../../store';

export const useEmployeesSearcherResults = () =>
    useSelector((state: TRootState) => getSearcherResults(state, 'employees'));
export const useVehiclesSearcherResults = () =>
    useSelector((state: TRootState) => getSearcherResults(state, 'vehicles'));
